import { NavigationSlider, Pagination } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'

type Props = {
  currentPosition: number
  pagination: Partial<Pagination>
  onNavigating?: (nextObjectIndex: number) => void
}

const NavigationBetweenObjects = ({
  currentPosition,
  pagination,
  onNavigating
}: Props) => {
  const { t } = useTranslation()

  return (
    <NavigationSlider
      backgroundColor='#004099'
      currentPosition={currentPosition + 1}
      first={1}
      total={1}
      showTotalPages={false}
      hasPreviousPage={!!pagination.hasPrevious}
      hasNextPage={!!pagination.hasNext}
      arrowOrientationButtons='diagonalArrows'
      hierarchyLevel='level_3'
      afterClick={onNavigating}
      heightClass='small'
      textForCurrent={t('navigation-slider.item')}
      ignoreHeight
    />
  )
}

export default NavigationBetweenObjects
